class ShouldDestroy {}

export default ShouldDestroy;
